import { render, staticRenderFns } from "./enrollDetailDialogs.vue?vue&type=template&id=9e70fe4a&scoped=true&"
import script from "./enrollDetailDialogs.vue?vue&type=script&lang=js&"
export * from "./enrollDetailDialogs.vue?vue&type=script&lang=js&"
import style0 from "./enrollDetailDialogs.vue?vue&type=style&index=0&id=9e70fe4a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e70fe4a",
  null
  
)

export default component.exports